export default __webpack_public_path__ + "static/personality-insightful-light-4cec511920d558f3d498090bc4ba4ff2.png";